import React, {Component} from 'react'
import PropTypes from 'prop-types'
import humanizeTime from '../../../../../helpers/time/humanizeTime'

class CreatedDate extends Component {
    render() {
        const {created} = this.props
        const textTime = created ? humanizeTime(created) : '-'

        return (
            <td className='CreatedDate'>
                {textTime}
            </td>
        )
    }
}

CreatedDate.propTypes = {
    created: PropTypes.string.isRequired,
}

export default CreatedDate
